module.exports = __webpack_public_path__ + "img/Tofi_letnia.640c1bda.jpg";